import { render, staticRenderFns } from "./TaxDataEditGeneral.vue?vue&type=template&id=5a3bab68&scoped=true&"
import script from "./TaxDataEditGeneral.vue?vue&type=script&lang=js&"
export * from "./TaxDataEditGeneral.vue?vue&type=script&lang=js&"
import style0 from "@/style/grid.css?vue&type=style&index=0&id=5a3bab68&scoped=true&lang=css&"
import style1 from "@/style/button.css?vue&type=style&index=1&id=5a3bab68&scoped=true&lang=css&"
import style2 from "@/style/input.css?vue&type=style&index=2&id=5a3bab68&scoped=true&lang=css&"
import style3 from "./TaxDataEditGeneral.vue?vue&type=style&index=3&id=5a3bab68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3bab68",
  null
  
)

export default component.exports